import { useContext } from 'react';

import { ExtContext } from './context';

const useExt = () => {
  const ext = useContext(ExtContext);

  return ext;
};

export default useExt;
